/**
 * @param {import('@/types/api').PosTaxInvoice | null | undefined} invoice
 */
export function getTaxInvoiceGuestLabel(invoice) {
  return invoice?.customer?.name ?? 'Walk-in customer'
}

/**
 * @param {import('@/types/api').PosTaxInvoice | null | undefined} invoice
 */
export function formatTaxInvoiceNumber(invoice) {
  return invoice?.invoice?.invoice_number ?? '—'
}

/**
 * @param {HTMLElement | null | undefined} node
 */
export function printTaxInvoice(node) {
  if (!node) return

  document.body.classList.add('printing-tax-invoice')
  window.print()
  window.addEventListener('afterprint', () => {
    document.body.classList.remove('printing-tax-invoice')
  }, { once: true })
}
